import React, { Component, Fragment } from "react";
import { withRouter } from "react-router-dom";
import MTI_01 from '../../images/landing/MTI_01.jpeg'
import MTI_02 from '../../images/landing/MTI_02.jpg'
import MTI_03 from '../../images/landing/MTI_03.jpeg'
import MTI_05 from '../../images/landing/MTI_05.png'
import MTI_06 from '../../images/landing/MTI_06.jpg'
import MTI_07 from '../../images/landing/MTI_07.jpg'
import MTI_08 from '../../images/landing/MTI_08.jpg'

import "./landing.scss";

const insures = [
  {
    id: 1, //ประกันเดินทางต่างประเทศ
    name: 'ประกันเดินทางต่างประเทศ (ตามไลฟ์สไตล์)',
    url: 'ta-sawasdee',
    img: MTI_07// 'https://www.mticonnect.com/Images/banner/banner-home.jpg'
  }, 
  {
    id: 2,
    name: 'ประกันเดินทางต่างประเทศ',
    url: 'ta-happy-trip',
    img: MTI_08// 'https://www.mticonnect.com/Images/banner/banner-home.jpg'
  },
  {
    id: 3,
    name: 'ประกันเดินทางในประเทศ',
    url: 'ta-assurance',
    img: MTI_06 //'https://www.mticonnect.com/Upload/ProductItem_FzBtQh_1534219457_76404_img1.jpg'
  },
  {
    id: 4,
    name: 'ประกันภัยอุบัติเหตุสำหรับคุณ',
    url: 'personal-assurance',
    img: MTI_03 //'https://www.mticonnect.com/Images/banner/banner-PA-Yourhappy.jpg'
  },
  // {
  //   id: 4,
  //   name: 'ประกันเดินทางในประเทศ',
  //   url: 'domestic-assurance',
  //   img: MTI_01 //'https://www.mticonnect.com/Upload/ProductItem_FzBtQh_1534219457_76404_img1.jpg'
  // },
  // {
  //   id: 4,
  //   name: 'ประกันอัคคีภัยสำหรับบ้านอยู่อาศัย',
  //   url: 'fire-assurance',
  //   img: MTI_05 //'https://www.mticonnect.com/Images/banner/banner-Fire.jpg'
  // },
]

class LandingPage extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className="landing-wrapper">
        {
          insures && 
          insures.map((insure, index) => {
            return (
              <div key={index} className="form-group box-item"
                onClick={() => this.props.history.push(insure.url)}>
                <img 
                  className="w-100"
                  src={insure.img} 
                  alt={insure.name}
                  />
                {/* <div class="box-banner position-abolute">
                  <div class="text-Banner">
                    <h3 class="title text-white">{insure.name}</h3>
                  </div>
                </div> */}
              </div>
            )
          })
        }
      </div>
    );
  }
}

export default withRouter(LandingPage);
